import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import './styles/flowIaFloating.css';
import './styles/reportsAnalytics.css';
import { AppProvider } from './context/AppContext';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Employees } from './pages/Employees';
import { OrgChart } from './pages/OrgChart';
import { Leaves } from './pages/Leaves';
import { ExpenseReports } from './pages/ExpenseReports';
import { PersonalFinance } from './pages/PersonalFinance';
import { Awards } from './pages/Awards';
import { Settings } from './pages/Settings';
import { ComingSoon } from './pages/ComingSoon';
import { FeedWall } from './pages/FeedWall';
import { Chat } from './pages/Chat';
import { DigitalLegajo } from './pages/DigitalLegajo';
import { PeopleIntelligence } from './pages/PeopleIntelligence';
import { EmployeePortal } from './pages/EmployeePortal';
import { Attendance } from './pages/Attendance';
import { Communications } from './pages/Communications';
import { Notifications } from './pages/Notifications';
import { PerformanceReviews } from './pages/PerformanceReviews';
import { Training } from './pages/Training';
import { ClimateSurveys } from './pages/ClimateSurveys';
import { EmployeeLifecycle } from './pages/EmployeeLifecycle';
import { Reports } from './pages/Reports';

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employee-lifecycle" element={<EmployeeLifecycle />} />
            <Route path="org-chart" element={<OrgChart />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="expense-reports" element={<ExpenseReports />} />
            <Route path="personal-finance" element={<PersonalFinance />} />
            <Route path="awards" element={<Awards />} />
            <Route path="settings" element={<Settings />} />
            <Route path="records" element={<DigitalLegajo />} />
            <Route path="documents" element={<ComingSoon moduleId="documents" />} />
            <Route path="employee-portal" element={<EmployeePortal />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="payroll-receipts" element={<ComingSoon moduleId="payrollReceipts" />} />
            <Route path="communications" element={<Communications />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="feed" element={<FeedWall />} />
            <Route path="chat" element={<Chat />} />
            <Route path="compliance" element={<ComingSoon moduleId="compliance" />} />
            <Route path="performance" element={<PerformanceReviews />} />
            <Route path="recruiting" element={<ComingSoon moduleId="recruiting" />} />
            <Route path="training" element={<Training />} />
            <Route path="surveys" element={<ClimateSurveys />} />
            <Route path="tasks" element={<ComingSoon moduleId="tasks" />} />
            <Route path="reports" element={<Reports />} />
            <Route path="people-intelligence" element={<PeopleIntelligence />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
